import moment from "moment";

function FormatDate(data: string | undefined): string {
  return moment(data).format("DD/MM/YYYY");
}

export default FormatDate;
